import React, { ReactNode } from 'react';
import moment from 'moment';
import { red, green } from '@mui/material/colors';
import { Typography, Stack } from '@mui/material';
import { Close, DoneAll } from '@mui/icons-material';

import { DateFormats } from '../../../constants/common';

const renderByStatus: Record<
  'SUCCESS' | 'FAILED',
  {
    icon: ReactNode;
    borderColor: string;
    prefix: 'Won' | 'Lost';
    textColor: 'error' | 'success';
  }
> = {
  SUCCESS: {
    prefix: 'Won',
    textColor: 'success',
    borderColor: green[100],
    icon: <DoneAll color="success" />,
  },
  FAILED: {
    prefix: 'Lost',
    textColor: 'error',
    borderColor: red[100],
    icon: <Close color="error" />,
  },
};

interface Props {
  id: string;
  isClosed: boolean;
  reasonLabel: string;
  closedDateTime: string;
  reopenAction?: ReactNode;
  closeDealStatus: 'SUCCESS' | 'FAILED';
}

export const ClosedDealInfo = ({ closeDealStatus, closedDateTime, reasonLabel, reopenAction }: Props) => (
  <Stack
    sx={{
      gap: '0.5rem',
      flexDirection: 'column',
      padding: '0.5rem 1rem',
      borderRadius: '0.5rem',
      boxShadow: ({ shadows }) => shadows[1],
      border: `1px solid ${renderByStatus[closeDealStatus].borderColor}`,
    }}
  >
    <Stack direction="row" gap="0.5rem">
      {renderByStatus[closeDealStatus].icon}

      <Stack>
        <Typography component="span" variant="subtitle2" color={renderByStatus[closeDealStatus].textColor}>
          {renderByStatus[closeDealStatus].prefix}: {moment(closedDateTime).format(DateFormats.TimeWithShortDate)}
        </Typography>

        <Typography component="span" variant="subtitle2" color={renderByStatus[closeDealStatus].textColor}>
          {reasonLabel}
        </Typography>
      </Stack>
    </Stack>

    {reopenAction}
  </Stack>
);
